import {
  // MdOutlineCastConnected,
  MdLocalPrintshop,
} from "@onemind-services-llc/react-icons-ng/md";
import { FaNetworkWired, FaHandsHelping } from "@onemind-services-llc/react-icons-ng/fa";
import { RiPrinterCloudLine } from "@onemind-services-llc/react-icons-ng/ri";
import { LiaNetworkWiredSolid } from "@onemind-services-llc/react-icons-ng/lia";
import { SiAntdesign } from "@onemind-services-llc/react-icons-ng/si";
import { GrVmware } from "@onemind-services-llc/react-icons-ng/gr";
import { BsHddNetworkFill } from "@onemind-services-llc/react-icons-ng/bs";
import { ContentCard } from "@/components/contentCard";
import {
  CLOUD_MIGRATIONS_ROUTES,
  MAIN_ROUTES,
  NETWORK_SERVICES_ROUTES,
} from "@/constants/routes";

export const TITLE = "Features of Network Services";

export const OPTIONS = [
  {
    icon: GrVmware,
    title: "Cloud Migration",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.NETWORK_SERVICES}${CLOUD_MIGRATIONS_ROUTES.EC2_TO_ZADARA}`}
        points={[
          "Migrate workloads from VMware, AWS, Azure, or GCP to OneMind’s secure cloud services.",
          "Seamless transition paths to MOST, Zadara, or OneMind PaaS with minimal downtime.",
          "Expert-led planning, execution, and validation for application, VM, and container migrations.",
        ]}
      />
    ),
  },
  // {
  //   icon: MdOutlineCastConnected,
  //   title: "Internet and DCI",
  //   content: (
  //     <ContentCard
  //       link={`${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.INTERNET_AND_DCI}`}
  //       points={[
  //         "High-speed, low-latency connectivity for uninterrupted business operations.",
  //         "Secure Data Center Interconnect (DCI) for efficient data exchange between multiple locations.",
  //         "Redundant network pathways for high availability and disaster recovery.",
  //       ]}
  //     />
  //   ),
  // },
  {
    icon: FaNetworkWired,
    title: "SDN | SD-WAN ",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.SDN_SD_WAN}`}
        points={[
          "Software-Defined Networking (SDN) & SD-WAN for agile, cloud-friendly connectivity.",
          "Optimized traffic management for better performance and cost savings.",
          "Seamless wired and wireless network integration for flexible, scalable access.",
        ]}
      />
    ),
  },
  {
    icon: RiPrinterCloudLine,
    title: "Unified Communication",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.CLOUD_UNIFIED_COMMUNICATION}`}
        points={[
          "VoIP, video conferencing, and real-time collaboration tools hosted in the cloud.",
          "AI-powered communication insights to enhance productivity.",
          "Secure and encrypted communication channels for data protection.",
        ]}
      />
    ),
  },
  {
    icon: LiaNetworkWiredSolid,
    title: "Wired and Wireless Infra",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.WIRED_AND_WIRELESS_NETWORKS}`}
        points={[
          "Enterprise-grade wired and Wi-Fi networks for seamless connectivity.",
          "Optimized bandwidth allocation for improved efficiency.",
          "Scalable infrastructure that supports IoT and remote workforce demands.",
        ]}
      />
    ),
  },
  {
    icon: SiAntdesign,
    title: "Network Design and Deployment",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.DESIGN_AND_DEPLOYMENT}`}
        points={[
          "End-to-end network architecture design for future-ready network infrastructure.",
          "Custom network deployment solutions for businesses of all sizes.",
          "Automated configuration & provisioning to reduce setup time.",
        ]}
      />
    ),
  },
  {
    icon: BsHddNetworkFill,
    title: "NMS | Observability | Custom Netbox",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.NETWORK_OBSERVABILITY_AND_NMS}`}
        points={[
          "Real-time network visibility to monitor traffic and performance.",
          "AI-driven anomaly detection for proactive troubleshooting.",
          "Automated alerts & diagnostics to enhance security and uptime.",
        ]}
      />
    ),
  },
  {
    icon: MdLocalPrintshop,
    title: "Managed Colocation",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.COLOCATION}`}
        points={[
          "Secure, high-performance colocation services for IT infrastructure hosting.",
          "Redundant power, cooling, and 24/7 monitoring for maximum uptime.",
          "Scalability options to meet evolving business needs.",
        ]}
      />
    ),
  },
  {
    icon: FaHandsHelping,
    title: "NOC | SOC | Helpdesk",
    content: (
      <ContentCard
        link={`${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.NOC_SOC_HELPDESK}`}
        points={[
          "24/7 network monitoring & management through Network Operations Center (NOC).",
          "Security Operations Center (SOC) for proactive threat detection & mitigation.",
          "IT Helpdesk services for quick troubleshooting and support.",
        ]}
      />
    ),
  },
];
